import {
  STATUS_ICON_CHECK_O,
  STATUS_ICON_LOADING,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_CLOCK
} from '@/common/utils/statuses';

// These interfaces mirror the real API response shape.
// Replace with @schema types once the backend schema package is updated.
export interface SchemaProgressUpdate {
  id: string;
  index: number;
  message: string;
  current_step: number;
  total_steps: number;
  created_at: string;
}

export interface SchemaBaseTask {
  id: string;
  task_type: string;
  status: string;
  instance: string;
  host: string | null;
  index: number;
  on_error: boolean;
  depends_on: string[] | null;
  exception_details: string | null;
  progress_updates: SchemaProgressUpdate[];
  created_at: string;
  updated_at: string | null;
}

export interface MappedProgressUpdate {
  id: string;
  index: number;
  message: string;
  currentStep: number;
  totalSteps: number;
  createdAt: string;
}

export const formatTaskType = (taskType: string): string => {
  const normalized = taskType.replace(/_/g, ' ').toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const taskStatusIcon = (status: string): string => {
  switch (status.toUpperCase()) {
    case 'COMPLETED': return STATUS_ICON_CHECK_O;
    case 'RUNNING': return STATUS_ICON_LOADING;
    case 'ERROR':
    case 'FAILED': return STATUS_ICON_TIMES_O;
    default: return STATUS_ICON_CLOCK;
  }
};

export const mapProgressUpdates = (updates: SchemaProgressUpdate[]): MappedProgressUpdate[] => (updates ?? [])
  .slice()
  .sort((a, b) => a.index - b.index)
  .map(p => ({
    id: p.id,
    index: p.index,
    message: p.message,
    currentStep: p.current_step,
    totalSteps: p.total_steps,
    createdAt: p.created_at
  }));
